// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_1Kz64","breadcrumb":"index_breadcrumb_t-mk0"};